/**
 * Canonical auth route paths used by the frontend and BFF routes.
 * Keep values centralized to avoid accidental slash/typo drift.
 */
export const AUTH_API_PATHS = {
  VERIFY: '/api/auth/verify/',
  ENSURE_SESSION: '/api/auth/ensure-session/',
  REFRESH: '/api/auth/refresh/',
  ME: '/api/auth/me/',
  LOGIN: '/api/auth/login/',
  MAGIC_LINK_REQUEST: '/api/auth/magic-link/request/',
  MAGIC_LINK_CALLBACK: '/api/auth/magic-link/callback/',
  CLEAR_SESSION: '/api/auth/clear-session/',
  SIGNOUT: '/api/auth/signout/',
  DOMAIN_SWITCH_START: '/api/auth/domain-switch/start/',
  DOMAIN_SWITCH_COMPLETE: '/api/auth/domain-switch/complete/',
  VERIFY_ADMIN: '/api/auth/verify-admin/',
  ADMIN_LOGIN: '/api/auth/admin/login/',
  ADMIN_LOGIN_START: '/api/auth/admin/login/start/',
  ADMIN_LOGIN_CALLBACK: '/api/auth/admin/login/callback/',
  ADMIN_ENSURE_SESSION: '/api/auth/admin/ensure-session/',
  ADMIN_IMPERSONATION_STATUS: '/api/auth/admin/impersonation-status/',
  ADMIN_MAGIC_LINK_REQUEST: '/api/auth/admin/magic-link/request/',
  ADMIN_SIGNOUT: '/api/auth/admin/signout/',
  ADMIN_REFRESH: '/api/auth/admin/refresh/',
  ADMIN_IMPERSONATE: '/api/auth/admin/impersonate/',
  ADMIN_IMPERSONATE_SYNC: '/api/auth/admin/impersonate/sync/',
} as const

export const BACKEND_AUTH_PATHS = {
  REFRESH: '/auth/refresh/',
  ME: '/auth/me/',
  LOGIN: '/auth/login/',
  MAGIC_LINK_REQUEST: '/auth/magic-link/request/',
  MAGIC_LINK_CONSUME: '/auth/magic-link/consume/',
  ADMIN_LOGIN: '/auth/admin/login/',
  ADMIN_MAGIC_LINK_REQUEST: '/auth/admin/magic-link/request/',
  ADMIN_VERIFY: '/auth/admin/verify/',
  ADMIN_REFRESH: '/auth/admin/refresh/',
  ADMIN_IMPERSONATE: '/auth/admin/impersonate/',
  ADMIN_IMPERSONATE_STATUS: '/auth/admin/impersonate/status/',
  ADMIN_IMPERSONATE_SYNC_TICKET: '/auth/admin/impersonate/sync-ticket/',
  ADMIN_IMPERSONATE_SYNC_TICKET_REDEEM:
    '/auth/admin/impersonate/sync-ticket/redeem/',
  DOMAIN_SWITCH_START: '/auth/domain-switch/start/',
  DOMAIN_SWITCH_REDEEM: '/auth/domain-switch/redeem/',
} as const
